import { useAppSelector } from '../../../redux/store';
import useGetData from '../../../Services/useGetData';
import globals from '../../../Globals.json';
import * as S from './styles';
import PanelLoading from '../../Loading/PanelLoading';
import { IProduct } from '../../../interfaces/IProduct';
import Format from '../../../Services/Format';
import { buildDashboardQuery, isRangeReady } from '../dateFilters';
import { MdImageNotSupported } from 'react-icons/md';

interface MostSaldProducts {
  product_id: number;
  total_quantity: string;
  total_sales: string;
  product: IProduct;

}

export function MostSoldProducts({
  start,
  end,
  startDate,
  endDate,
  title
}: {
  start: number;
  end?: number;
  startDate: string;
  endDate: string;
  title: string
}) {
  const { stores, storeActive } = useAppSelector(
    ({ storeMeReducer }) => storeMeReducer.value
  );

  // "Menos Vendidos" tem endpoint próprio; qualquer outro título cai no de
  // mais vendidos.
  const path = title.includes("Menos")
    ? globals?.api?.minusSoldProducts
    : globals?.api?.mostSoldProducts;

  const rangeReady = isRangeReady(startDate, endDate);

  const { data, isFetching } = useGetData({
    path,
    query: buildDashboardQuery({ storeId: storeActive?.id, startDate, endDate }),
    enabled: !!storeActive?.id && rangeReady,
  });

  return (
    <S.Container>
      <div className="header">
        <h3>{title}</h3>
        <span className="details-link">Ver detalhes</span>
      </div>
      <div className="cards">
        {isFetching && !data ? (
          <PanelLoading />
        ) : data?.products?.length > 0 ? (
          data?.products?.slice(start, end)?.map((product: any, index: number) => (
            <div key={product?.product_id} className="wrapper">
              <div className="position">
                <span>{index + 1}º</span>
              </div>
              <div className="img">
                {product?.image ? (
                  <img
                    src={product.image}
                    alt={product?.product_name}
                    onError={(e) => {
                      e.currentTarget.style.display = 'none';
                      e.currentTarget.nextElementSibling?.classList.remove('hidden');
                    }}
                  />
                ) : null}
                <MdImageNotSupported
                  className={product?.image ? 'hidden' : ''}
                  size={22}
                />
              </div>
              <div className="description">
                <span className="name">{product?.product_name}</span>
                <span className="category">
                  {product?.relationships?.category?.name || product?.category?.name}
                </span>
              </div>
              <div className="details">
                <span className="sales">
                  {Format.formatCurrencyBr(product?.total_value)}
                </span>
                <span className="qtd">{product?.total_qty} pedido{Number(product?.total_qty) > 1 ? 's' : ''}</span>
              </div>
            </div>
          ))
        ) : (
          <div className="not-data">Nenhuma venda no período selecionado.</div>
        )}
      </div>
    </S.Container>
  );
}
